import c from "./consts";

export default {
    [c.APP_INITIALIZED]: false,
};